import React from "react";
import { size } from "lodash";
import { IllustrationProps } from ".";

export default ({
  colors: {
    base,
    scheme,
    chart: { primary },
  },
}: IllustrationProps) => {
  const numberOfColors = size(scheme);
  const _scheme =
    numberOfColors === 0
      ? [primary, base]
      : numberOfColors === 1
      ? [...scheme, base]
      : scheme;

  return (
    <svg width="100%" height="100%" viewBox="0 0 440 120">
      {/* 4 */}
      <path
        d="M435 103a5 5 0 110 10H5a5 5 0 110-10h430zm0-26a5 5 0 110 10H5a5 5 0 010-10h430zm0-26a5 5 0 110 10H5a5 5 0 010-10h430zm0-26a5 5 0 110 10H5a5 5 0 010-10h430zm0-25a5 5 0 110 10H5A5 5 0 115 0h430z"
        fill={_scheme[3] || _scheme[1]}
      />
      {/* 1 */}
      <path
        d="M106 103a5 5 0 110 10H5a5 5 0 110-10h101zm30-26a5 5 0 110 10H5a5 5 0 010-10h131zm-7-26a5 5 0 110 10H5a5 5 0 010-10h124zM93 25a5 5 0 010 10H5a5 5 0 010-10h88zm4-25a5 5 0 010 10H5A5 5 0 115 0h92z"
        fill={_scheme[0]}
      />
      {/* 2 */}
      <path
        d="M337 103v10H84v-10h253zm-21-26v10H135V77h181zm0-26v10H86V51h230zm0-26v10H86V25h230zM302 0v10H72V0h230z"
        fill={_scheme[2] ? _scheme[1] : _scheme[0]}
      />
      {/* 3 */}
      <path
        d="M383 103v10h-65v-10h65zm-22-26v10h-65V77h65zm0-26v10h-65V51h65zm0-26v10h-65V25h65zM347 0v10h-65V0h65z"
        fill={_scheme[2] || _scheme[1]}
      />
    </svg>
  );
};
